<template>
  <div class="user-app-list-page w-100">
    <basic-subheader>
      <template #filters>
        <b-row class="py-3">
          <b-col>
            <basic-input label="Mã khảo sát" placeholder="Nhập mã khảo sát" name="code" class="quize-input"
              :value.sync="filters.code" :debounce="2000"
              @v-modal:update="searchDebounce('code', $event)"></basic-input>
          </b-col>
          <b-col>
            <basic-input label="Tên khảo sát" placeholder="Nhập tên khảo sát" name="name" class="quize-input"
              :value.sync="filters.name" :debounce="2000"
              @v-modal:update="searchDebounce('name', $event)"></basic-input>
          </b-col>
          <b-col>
            <basic-select label="Trạng thái" placeholder="--- Chọn trạng thái ---" name="type" :solid="false"
              :allowEmpty="true" value-label="text" track-by="value" class="quize-select" :options="statuses"
              :value.sync="filters.status" @update:value="searchStatus" />
          </b-col>
        </b-row>
      </template>
      <template v-if="isInsertPermission" v-slot:actions>
        <b-button class="btn btn-success" type="button" @click="createSurvey">
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/Neolex/Basic/plus.svg" />
          </span>
          Thêm mới
        </b-button>
      </template>
    </basic-subheader>
    <Wrapper>
      <template-table :column="column" :data="data" :paging="paging" :tableAction="false" :selectAction="false"
        :searchAction="false" @sortBy="sortRequest">
        <template v-slot:body="{ item }">
          <td>
            {{ item.code }}
          </td>
          <td class="cell-overflow">
            <div class="text-overflow">
              {{ item.name }}
            </div>
          </td>
          <td style="width: 20px">
            <action-dropdown :value="item" :show_copy="false" :show_view="false" :show_delete="showBtnInactive(item)"
              :show_edit="false" :boundary="data.length > 2 ? 'scrollParent' : 'window'"
              @delete="showPopupChangeStatus(item.id, 0)"  >
              <template>
                <b-dropdown-text tag="div" class="navi-item cursor-pointer" @click="viewSurvey(item)">
                  <a class="navi-link text-primary">
                    <span class="menu-icon svg-icon svg-icon-sm">
                      <inline-svg class="svg-icon" src="/media/svg/icons/Neolex/Basic/eye.svg" />
                    </span>
                    <span class="navi-text text-primary">Xem chi tiết khảo sát</span>
                  </a>
                </b-dropdown-text>
                <b-dropdown-divider v-if="isDeletePermission"></b-dropdown-divider>
                <template v-if="isDeletePermission">
                  <b-dropdown-text tag="div" class="navi-item cursor-pointer" @click="editSurvey(item)">
                    <a class="navi-link text-primary">
                      <span class="menu-icon svg-icon svg-icon-sm">
                        <inline-svg class="svg-icon" src="/media/svg/icons/Neolex/Basic/edit-2.svg" />
                      </span>
                      <span class="navi-text text-primary">Chỉnh sửa khảo sát</span>
                    </a>
                  </b-dropdown-text>
                </template>
                <template v-if="isInsertPermission">
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-text tag="div" class="navi-item cursor-pointer">
                    <a class="navi-link text-primary" @click.stop="copySurvey(item)">
                      <span class="menu-icon svg-icon svg-icon-sm">
                        <inline-svg class="svg-icon" src="/media/svg/icons/Neolex/Basic/copy.svg" />
                      </span>
                      <span class="navi-text text-primary">Sao chép khảo sát</span>
                    </a>
                  </b-dropdown-text>
                </template>
                <template v-if="isDeletePermission">
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-text tag="div" class="navi-item cursor-pointer">
                    <a class="navi-link text-primary" @click.stop="copyLinkSurvey(item)">
                      <span class="menu-icon svg-icon svg-icon-sm">
                        <inline-svg class="svg-icon" src="/media/svg/icons/Neolex/Basic/copy.svg" />
                      </span>
                      <span class="navi-text text-primary">Chia sẻ link khảo sát</span>
                    </a>
                  </b-dropdown-text>
                  <b-dropdown-divider></b-dropdown-divider>
                  <template v-if="showBtnActiveAndBeta(item)">
                    <b-dropdown-text tag="div" class="navi-item cursor-pointer"
                      @click="showPopupChangeStatus(item.id, 3)">
                      <a class="navi-link text-warning">
                        <span class="menu-icon svg-icon svg-icon-sm">
                          <inline-svg class="svg-icon" src="/media/svg/icons/Neolex/Basic/power.svg" />
                        </span>
                        <span class="navi-text text-warning">Beta</span>
                      </a>
                    </b-dropdown-text>
                    <b-dropdown-divider></b-dropdown-divider>
                  </template>
                  <template v-if="showBtnActive(item) || showBtnActiveAndBeta(item)">
                    <b-dropdown-text tag="div" class="navi-item cursor-pointer"
                      @click="showPopupChangeStatus(item.id, 1)">
                      <a class="navi-link text-primary">
                        <span class="menu-icon svg-icon svg-icon-sm">
                          <inline-svg class="svg-icon" src="/media/svg/icons/Neolex/Basic/power.svg" />
                        </span>
                        <span class="navi-text text-primary">Active</span>
                      </a>
                    </b-dropdown-text>
                  </template>
                </template>
              </template>
            </action-dropdown>
          </td>
          <td class="text-center">
            {{ item.questionCount }}
          </td>
          <td class="text-center">
            {{ formatDate(item.updateDatetime) }}
          </td>
          <td>
            <div class="status" :class="getStatus(item.status)">
              {{ getStatus(item.status) }}
              <div v-if="showBtnActive(item)" class="beta">TN</div>
            </div>
          </td>
        </template>
      </template-table>
    </Wrapper>
  </div>
</template>
<script>
import { CHANGE_STATUS_SURVEY } from '@/core/services/store/survey.module';
import { createNamespacedHelpers } from 'vuex';
const { mapActions } = createNamespacedHelpers('survey');
export default {
  name: 'SurveyList',
  data() {
    return {
      paging: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      column: [
        {
          key: 'code',
          label: 'Mã',
          sortable: true,
          style: {
            width: '10%',
          },
        },
        {
          key: 'name',
          label: 'Tên khảo sát',
          sortable: true,
        },
        {
          key: 'actionDropdown',
          label: '',
          sortable: false,
          style: {
            width: '20px',
          },
        },
        {
          key: 'questionCount',
          label: 'Số câu hỏi',
          sortable: true,
          style: {
            width: '125px',
          },
          class: 'question-count',
        },
        {
          key: 'lastUpdate',
          label: 'Cập nhật lần cuối',
          sortable: false,
          class: 'text-center',
          style: {
            width: '170px',
          },
        },
        {
          key: 'status',
          label: 'Trạng thái',
          sortable: false,
          style: {
            width: '5%',
          },
        },
      ],
      data: [],
      filters: {
        status: null,
        code: null,
        name: null,
      },
      sort: {
        by: null,
        order: null,
      },
      orderByExtend: {
        by: null,
        order: null,
      },
      statuses: [
        {
          text: 'Draft',
          value: '2',
        },
        {
          text: 'Active',
          value: '1',
        },
        {
          text: 'Inactive',
          value: '0',
        },
        {
          text: 'Beta',
          value: '3',
        },
      ],
    };
  },
  computed: {
    searchParams() {
      return {
        orderBy: this.sort.by ? `${this.sort.by} ${this.sort.order}` : null,
        orderByExtend: this.orderByExtend.by
          ? `${this.orderByExtend.by} ${this.orderByExtend.order}`
          : null,
        page: this.paging.page,
        size: this.paging.pageSize,
        status: this.filters.status?.value || null,
        code: this.filters.code || null,
        name: this.filters.name || null,
      };
    },
  },
  watch: {
    'paging.page'() {
      this.loadData();
    },
    'paging.pageSize'() {
      this.loadData();
    },
  },
  created() {
    this.loadData();
  },
  methods: {
    ...mapActions({ CHANGE_STATUS_SURVEY }),
    createSurvey() {
      this.$router.push({
        name: 'survey_create',
      });
    },
    sortRequest(val) {
      if (val.column === 'questionCount') {
        this.orderByExtend.by = val.column;
        this.orderByExtend.order = val.order;
        this.sort.by = null;
        this.sort.order = null;
      } else {
        this.sort.by = val.column;
        this.sort.order = val.order;
        this.orderByExtend.by = null;
        this.orderByExtend.order = null;
      }
      this.loadData();
    },
    async loadData() {
      this.$store.commit('context/setLoading', true);
      try {
        const { meta, data } = await this.$api.get('/Survey', {
          params: this.searchParams,
        });
        if (!meta.success) {
          return this.$toastr.e({
            title: 'Lỗi !',
            msg: meta.message,
          });
        }
        this.data = data;
        this.paging.total = meta.total;
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi !',
          msg: error,
        });
      } finally {
        this.$store.commit('context/setLoading', false);
      }
    },
    searchDebounce(type, value) {
      if (type === 'code') {
        this.filters.code = value;
      } else {
        this.filters.name = value;
      }
      this.resetPaging();
    },
    resetPaging() {
      this.paging.page = 1;
      this.loadData();
    },
    searchStatus(value) {
      this.filters.status = value
        ? this.statuses.find((el) => el.value === value)
        : null;
      this.resetPaging();
    },
    getStatus(status) {
      switch (status) {
        case 0:
          return 'inactive';
        case 1:
          return 'active';
        case 3:
          return 'active';

        default:
          return 'draft';
      }
    },
    formatDate(date) {
      const isValid = this.$moment(date, 'MM/DD/YYYY HH:mm:ss').isValid();
      if (!isValid) return null;
      return this.$moment(date).format('DD/MM/YYYY');
    },
    showBtnActive(item) {
      return item.status === 3;
    },
    showBtnInactive(item) {
      return item.status === 1;
    },
    showBtnActiveAndBeta(item) {
      return [0, 2].includes(item.status);
    },
    getNameStatus(state) {
      switch (state) {
        case 1:
          return 'Active';
        case 0:
          return 'Inactive';

        default:
          return 'Beta';
      }
    },
    showPopupChangeStatus(id, state) {
      this.$swal({
        title: 'Xác nhận',
        text: `Bạn có chắc chắn muốn chuyển trạng thái thành ${this.getNameStatus(
          state,
        )} không?`,
        icon: 'warning',
        buttons: {
          cancel: {
            text: 'Huỷ bỏ',
            value: false,
            visible: true,
            className: '',
            closeModal: true,
          },
          confirm: {
            text: 'Xác nhận',
            value: true,
            visible: true,
            className: '',
            closeModal: true,
          },
        },
      }).then(
        function (result) {
          if (result) {
            // inactive all
            this.changeStatus(id, state);
          }
        }.bind(this),
      );
    },
    async changeStatus(id, state) {
      this.$store.commit('context/setLoading', true);
      const params = {
        id,
        state,
      };
      const { error } = await this.CHANGE_STATUS_SURVEY(params);
      if (!error) {
        this.$toastr.s({
          title: 'Thành công !',
          msg: 'Cập nhật thành công',
        });
        this.loadData();
      } else {
        this.$toastr.e({
          title: 'Lỗi !',
          msg: error.message,
        });
      }
      this.$store.commit('context/setLoading', false);
    },
    viewSurvey(item) {
      this.$router.push({
        name: 'survey_detail',
        params: {
          id: item.id,
        },
      });
    },
    editSurvey(item) {
      this.$router.push({
        name: 'survey_edit',
        params: {
          id: item.id,
        },
      });
    },
    copySurvey(item) {
      this.$router.push({
        name: 'survey_create',
        query: {
          surveyId: item.id,
        },
      });
    },
    async copyLinkSurvey(item) {

      try {
              this.$store.commit('context/setLoading', true);

        let link = item.dynamicLink;

        if (link==null) {
          const res = await this.$api.put(`Survey/UpdateDynamicLink/${item.id}`, {
            code: item.code,
            coverId: item.coverId,
            name: item.name
          });
          link = res.data.dynamicLink;
        }

        await navigator.clipboard.writeText(link);
        this.$toastr.s({
          title: 'Thành công!',
          msg: 'Đã sao chép link',
        });
      }
      catch (err) {
        this.$toastr.e({
          title: 'Thất bại!',
          msg: 'Sao chép link thất bại' || err,
        });
      }
      finally {
        this.$store.commit('context/setLoading', false);
      }
    }


  }

};
</script>
<style lang="scss" scoped>
.mw-400 {
  min-width: 400px;
}

.status {
  padding: 6px 24px;
  border-radius: 20px;
  color: #fff;
  text-transform: capitalize;
  width: 96px;
  text-align: center;
  position: relative;

  &.active {
    background: #21a567;
  }

  &.inactive {
    background: #ff5756;
  }

  &.draft {
    background: #888c9f;
  }
}

.beta {
  background: #fed31b;
  border-radius: 12px;
  position: absolute;
  top: -10px;
  right: -10px;
  padding: 2px 6px;
}

.quize-input {
  min-width: 220px;
}

.text-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cell-overflow {
  max-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
<style lang="scss">
.quize-select {
  .multiselect {
    min-width: 220px;
  }
}

.question-count {
  .sorting {
    justify-content: center;
    padding-right: 0;
  }
}
</style>
